import marketingTemplate from "./saksham-marketing";

// Reuse the approved master verbatim apart from Interiors identity/contact data
// and a proportional 240px-wide logo (the supplied asset is 2000 x 667).
export default marketingTemplate
  .replace(/Saksham Marketing/g, "Saksham Interiors")
  .replace(/sakshammarketing\.in/g, "sakshaminteriors.in")
  .replace("+91 80 4224 7140 ext 201", "+91 80 4224 7140")
  .replace("Shop #02, No 15 &amp; 16, Ground Floor,", "No 15 &amp; 16, Ground Floor,")
  .replace("18th “A” Cross, Dasarahalli Main Road,", "18th ‘A’ Cross, Dasarahalli Main Road,")
  .replace("Bhuvaneshwarinagara, Hebbal Kempapura,", "Bhuvaneshwari nagara, Hebbal Kempapura,")
  .replace("Bangalore-560 024", "Bengaluru-560 024")
  .replace(
    'width="296" height="80" style="display:block;border:0;width:296px;height:80px;',
    'width="240" height="80" style="display:block;border:0;width:240px;height:auto;'
  );
